// Direct-to-instant-aio-api fetch helpers, mirroring kwik-assistant's own
// Utils/api.js (timeout + 502 retry), parameterized by the caller's own
// token instead of a module-level singleton, since two independent native
// surfaces (sidebar + fullTab) may hold their own session state.

const buildHeaders = (accessToken, formdata = false) => {
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    }
    if (!formdata)
        headers['content-type'] = 'application/json'
    return headers
}

async function fetchWithTimeout(resource, options = {}) {
    const { timeout = 8000 } = options

    const controller = new AbortController()
    let id = 0
    if (timeout)
        id = setTimeout(() => controller.abort(), timeout)

    let response = null
    try {
        response = await fetch(resource, {
            ...options,
            signal: controller.signal
        })
    } catch (e) {
        console.error(e)
        response = e
    }
    clearTimeout(id)

    return response
}

export const cortexGet = async (url, accessToken, timeout = 0, attempt = 3) => {
    const res = await fetchWithTimeout(url, {
        timeout,
        method: 'GET',
        headers: buildHeaders(accessToken)
    })
    if (res.status === 502 && attempt !== 0) {
        await new Promise(resolve => setTimeout(resolve, 1000))
        return cortexGet(url, accessToken, timeout, attempt - 1)
    }
    return res
}

export const cortexPost = async (url, accessToken, payload, timeout = 0, attempt = 3) => {
    const res = await fetchWithTimeout(url, {
        timeout,
        body: JSON.stringify(payload),
        method: 'POST',
        headers: buildHeaders(accessToken)
    })
    if (res.status === 502 && attempt !== 0) {
        await new Promise(resolve => setTimeout(resolve, 1000))
        return cortexPost(url, accessToken, payload, timeout, attempt - 1)
    }
    return res
}

export const cortexPatch = async (url, accessToken, payload, timeout = 0, attempt = 3) => {
    const res = await fetchWithTimeout(url, {
        timeout,
        body: JSON.stringify(payload),
        method: 'PATCH',
        headers: buildHeaders(accessToken)
    })
    if (res.status === 502 && attempt !== 0) {
        await new Promise(resolve => setTimeout(resolve, 1000))
        return cortexPatch(url, accessToken, payload, timeout, attempt - 1)
    }
    return res
}

export const cortexDelete = async (url, accessToken, timeout = 0, attempt = 3) => {
    const res = await fetchWithTimeout(url, {
        timeout,
        method: 'DELETE',
        headers: buildHeaders(accessToken)
    })
    if (res.status === 502 && attempt !== 0) {
        await new Promise(resolve => setTimeout(resolve, 1000))
        return cortexDelete(url, accessToken, timeout, attempt - 1)
    }
    return res
}

export const cortexHeaders = buildHeaders
